import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import './assets/css/tailwind.output.css'
import App from './App'



const Wrapper = () => (
    <Router>
        <Switch>
            <Route path="*" exact component={App} />
        </Switch>
    </Router>
);
ReactDOM.render(<Wrapper />, document.getElementById('root'));